//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'

export default {
  name: 'AppHeader',
  props: {
    title: {
      type: String
    },
    showBack: {
      type: Boolean,
      default: true
    },
    showSearch: {
      type: Boolean,
      default: false
    },
    showMore: {
      type: Boolean,
      default: true
    },
    preventBack: {
      type: Boolean,
      default: true
    },
    backRouter: {
      type: Object
    },
    redefineClickBack: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showMenus: false,
      menus: {}
    }
  },
  computed: {
    ...mapGetters([
      'language'
    ])
  },
  created() {
    if (this.language) {
      this.initMenus()
    }
  },
  methods: {
    initMenus() {
      this.menus = {}
      this.$set(this.menus, 'home', this.$t('home'))
      // this.$set(this.menus, 'language', this.language === 'zh' ? 'Language: English' : '语言：中文')
    },
    handleSearch() {
      this.$router.push({ name: 'SearchIndex' })
    },
    handleHome() {
      this.$router.push({ name: 'TopicIndex' })
    },
    handleClickMore() {
      this.showMenus = true
    },
    handleClickMenu(key, item) {
      if (key === 'home') {
        this.handleHome()
      } else if (key === 'language') {
        this.$i18n.locale = this.language === 'zh' ? 'en' : 'zh'
        this.$store.commit('SET_LANGUAGE', this.language === 'zh' ? 'en' : 'zh')
      }
      this.showMenus = false
      this.initMenus()
    },
    handleClickBack() {
      if (this.redefineClickBack) {
        this.$emit('on-click-back')
      } else {
        if (this.backRouter) {
          this.$router.push(this.backRouter)
        } else if (history.length <= 2) {
          this.$router.replace(this.$store.getters.token ? { path: '/contacts' } : { path: '/t' })
        } else if (this.$route.query.hasOwnProperty('oauth')) {
          this.$router.replace(this.$store.getters.token ? { path: '/contacts' } : { path: '/t' })
        } else {
          history.back()
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Header.vue